import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaComponent {
  idPagadora
  idProyecto

  constructor (ViaticosProyectos, $location) {
    this.ViaticosProyectos = ViaticosProyectos
    this.$location = $location
  }

  $onInit () {
    this.promise = this.traerProyectos()
    this.id_proyecto = this.idProyecto || undefined
  }

  traerProyectos () {
    return this.ViaticosProyectos.get()
      .then(({data}) => (this.proyectos = data))
  }

  buscar () {
    this.$location.search({
      idProyecto: this.id_proyecto,
    })
  }

}

module.component('viaticosConfiguracionEmpresa', {
  controller: ViaticosConfiguracionEmpresaComponent,
  template,
  bindings: {
    idPagadora: '<',
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/component.js